import React from 'react';

import ClientSearchResults from './ClientSearchResultsApp';

const ClientSearchResultsEntry = () => {
  return <ClientSearchResults />;
};

export default ClientSearchResultsEntry;
